export default "__VITE_ASSET__CSqPLkB0__"